import React from "react";
import { motion } from "framer-motion";
import { Star, Quote } from "lucide-react";

const testimonials = [
  { name: "Priya & Karthik M.", location: "Bangalore", condition: "Fertility Support", result: "After 3 years of trying, we finally conceived naturally within 4 months of following Fitly's fertility nutrition program. The customized diet and guidance changed everything for us!" },
  { name: "Roshni G.", location: "Pune", condition: "PCOS & Insulin Resistance", result: "My fasting insulin was 28 and I had severe PCOS. Within 3 months, insulin dropped to 9, lost 10 kgs, and my cycles returned on their own. Truly life-changing!" },
  { name: "Deepika V.", location: "Mumbai", condition: "IVF Support", result: "Failed 2 IVF cycles before finding Fitly. Their pre-IVF nutrition protocol prepared my body perfectly. Third cycle was successful!" }
];

export default function ConsultationTestimonials() {
  return (
    <section className="mt-20 border-t border-border_custom pt-16" data-testid="consultation-testimonials">
      <motion.div className="text-center mb-10"
        initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.5 }}>
        <span className="text-xs tracking-[0.2em] uppercase font-semibold text-accent">Real Results</span>
        <h2 className="font-serif text-2xl sm:text-3xl text-emerald_deep mt-2">What Our Clients Say</h2>
        <div className="flex items-center justify-center gap-1 mt-3">
          {[...Array(5)].map((_, i) => <Star key={`header-star-${i}`} size={14} className="fill-accent text-accent" />)}
          <span className="text-sm text-text_muted ml-2">4.9 from 114+ reviews</span>
        </div>
      </motion.div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {testimonials.map((t, idx) => (
          <motion.div key={t.name} data-testid={`consultation-testimonial-${t.name.split(" ")[0].toLowerCase()}`}
            className="bg-surface border border-border_custom p-6 rounded-xl relative"
            initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            transition={{ duration: 0.5, delay: idx * 0.15 }}>
            <Quote size={24} className="text-accent/20 absolute top-4 right-4" />
            <div className="flex items-center gap-1 mb-3">
              {[...Array(5)].map((_, i) => <Star key={`card-star-${i}`} size={12} className="fill-accent text-accent" />)}
            </div>
            <p className="text-sm text-text_muted leading-relaxed mb-4">{t.result}</p>
            <div className="border-t border-border_custom pt-3">
              <p className="text-sm font-semibold text-emerald_deep">{t.name}</p>
              <p className="text-xs text-accent">{t.condition} &mdash; {t.location}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
